module.exports = __webpack_public_path__ + "img/watching-an-e-sport-game.47b88419.svg";